<title mat-dialog-title>{{ "map.operationalViews.selectDashboardDialog" | t }}</title>
<mat-dialog-content>
  <sn-searchbar (valueChange)="onSearchValueChange($event)"></sn-searchbar>
  <sn-data-list #list reloadByQueryParams [fetchFn]="loadData">
    <sn-infinite-scroll windowScrollTarget>
      <ng-template [ngIf]="list.dataSource.data.length" [ngIfThen]="listTmpl"></ng-template>
      <ng-template
        [ngIf]="!list.dataSource.data.length && list.dataIsInited"
        [ngIfThen]="emptyTmpl"
      ></ng-template>
    </sn-infinite-scroll>
  </sn-data-list>
</mat-dialog-content>
<mat-dialog-actions snButtonGroup>
  <sn-button color="danger" (click)="cancel()">{{ "common.cancel" | t }}</sn-button>
</mat-dialog-actions>

<ng-template #listTmpl>
  <mat-table [dataSource]="list.dataSource.data">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>{{ "common.name" | t }}</mat-header-cell>
      <mat-cell *matCellDef="let view">
        {{ view.name }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="widgets">
      <mat-header-cell *matHeaderCellDef>{{ "common.widgets" | t }}</mat-header-cell>
      <mat-cell *matCellDef="let view">
        {{ view.widgets.length }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row (click)="onSelected(view)" *matRowDef="let view; columns: columns"> </mat-row>
  </mat-table>
</ng-template>

<ng-template #emptyTmpl>
  <sn-empty-state icon="cancel_presentation" [title]="'common.noResults' | t">
    {{ "common.noResultsMatchSearch" | t }}
  </sn-empty-state>
</ng-template>
